import {
    createBrowserRouter,
} from "react-router-dom";
import Dashboard from "./pages/dashboard/dashboard";
import NotFound from "./pages/notfound/NotFound";
import Clusters from "./pages/clusters/clusters";
import Home from "./pages/home/home";
import VerifyEmail from "./pages/verify_email/verify_email";
import { ProtectedRoute } from "./components/ProtectedRoute";
import {PublicRoute} from "./components/PublicRoute"
import Signup from "./pages/signup/signup";
import ForgotPassword from "./pages/forgot_password/forgot_password";
import ResetPassword from "./pages/reset_password/reset_password";
import DsrcOverview from "./pages/datasources/datasource";
import AuthCallback from "./pages/auth_sso/auth_callback";
import Crashlog from "./pages/crashlog/crashlog";
import DbQueryRunner from "./pages/db_query/db_query_runner";
import DataFiles from "./pages/data_files/data_files";
import AllFiles from "./pages/all_files/all_files";
import ClusterDebugInfoPage from "./pages/cluster_debug/cluster_debug_info_page";

const router = createBrowserRouter([
    {
        path: "/",
        element: <PublicRoute><Home/></PublicRoute>,
    },
    {
        path: "/signup",
        element: <PublicRoute><Signup/></PublicRoute>,
    },
    {
        path: "/forgot-password",
        element: <PublicRoute><ForgotPassword/></PublicRoute>
    },
    {
        path: "/reset_password/:token",
        element: <PublicRoute><ResetPassword/></PublicRoute>
    },
    {
        path: "/dashboard",
        element: <ProtectedRoute><Dashboard/></ProtectedRoute>,
    },
    {
        path: "/dashboard/:clusterName/datasources/overview",
        element: <ProtectedRoute><DsrcOverview/></ProtectedRoute>,
    },
    {
        path: "/clusters",
        element: <ProtectedRoute><Clusters/></ProtectedRoute>
    },
    {
        path: "/files/:clusterName/:tableName",
        element: <ProtectedRoute><DataFiles/></ProtectedRoute>
    },
    {
        path: "/allfiles/:clusterName",
        element: <ProtectedRoute><AllFiles/></ProtectedRoute>
    },
    {
        path: "/cluster_debug_info/:clusterName",
        element: <ProtectedRoute><ClusterDebugInfoPage/></ProtectedRoute>
    },
    {
        path: "/crashlog/:clusterName",
        element: <ProtectedRoute><Crashlog/></ProtectedRoute>
    },
    {
        path: "/query_database",
        element: <ProtectedRoute><DbQueryRunner/></ProtectedRoute>
    },
    {
        path: "/verify/:token",
        element: <PublicRoute><VerifyEmail/></PublicRoute>
    },
    {
        path: "/auth/callback",
        element: <PublicRoute><AuthCallback/></PublicRoute>
    },
    {
        path: "*",
        element: <NotFound />
    }
]);

export default router